/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Boolean/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function Boolean({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/Content/ActiveStep/None/Boolean",
  onChange,
  isSubmitting
  
}) {
let stepValueValueData = fromData.useDataValue({ viewPath,
context: 'step',
path: 'value',
})
let stepValueChangeData = fromData.useDataChange({ viewPath,
context: 'step',
path: 'value',
})
let stepsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'steps',
})
let stepDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'step',
path: 'description',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 data="step.value"
 value={stepValueValueData}
 onChange={stepValueChangeData}
 data="steps"
 disabled={stepsIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 data="step.description"
 text={stepDescriptionValueData}
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}